module.exports = __webpack_public_path__ + "static/media/Why-two.a8af6e1d.svg";